export const RECIPE_CONSTANTS = {
  heading: 'Receta Médica',
  medicine: 'Medicamento',
  medicinePlaceholder: 'Nombre comercial del medicamento',
  quantity: 'Cantidad',
  quantityPlaceholder: '5 tabletas / 1 frasco / 2 sobres',
  instructions: 'Indicaciones',
  instructionsPlaceholder: 'Indicar como se debe tomar el medicamento',
  generate: 'Generar Receta'
};
